module.exports = __webpack_public_path__ + "img/81ne.553ad773.svg";